import { render, staticRenderFns } from "./OrdersIcon.vue?vue&type=template&id=edb1b1a0"
import script from "./OrdersIcon.vue?vue&type=script&lang=ts"
export * from "./OrdersIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports